// page_name##页面名称(1:商品详情页)
const page_name = 1
export default {
  /** 华丽的分割线-开始 */

  // 商品主图点击
  // page_name##页面名称(1:商品详情页 2: 团购页面)&&
  // position##位置&&
  // img_content##内容id(1:图片;2:视频;3:视频纯封面)&&
  // back_color##图片位置背景色(1:渐变;2:常规)&&
  // sku_id##商品skuid
  bannerClick: ({ position, img_content, back_color, sku_id, page_name = 1 }) => ({
    act: 'click',
    params: {
      cfrom: '171|001|01|077',
      event_id: '171|001|01|077',
      page_name,
      position,
      img_content,
      back_color,
      sku_id
    }
  }),

  // 商品主图曝光
  bannerShow: ({ position, img_content, back_color, sku_id, page_name = 1 }) => ({
    cfrom: '171|001|02|077',
    event_id: '171|001|02|077',
    page_name,
    position,
    img_content,
    back_color,
    sku_id
  }),

  three3DShow: ({ sku_id }) => ({
    cfrom: '207|001|02|077',
    event_id: '207|001|02|077',
    sku_id
  }),

  // 跟随视频曝光时上报
  // page_name##页面名称(1:商品详情页)&&
  // sku_id##商品skuid
  // video_content##按钮内容id(1:静音;2:关闭)--click
  smallVideo: ({ sku_id, video_content }) => [
    {
      act: 'show',
      params: { cfrom: '171|002|02|077', event_id: '171|002|02|077', page_name, sku_id }
    },
    {
      act: 'click',
      params: { cfrom: '171|002|01|077', event_id: '171|002|01|077', page_name, sku_id, video_content }
    }
  ],

  // 商品主图评价气泡曝光点击
  // page_name##页面名称(1:商品详情页)&&
  // position##位置&&
  // sku_id##商品skuid
  evaluate: ({ sku_id, position }) => [
    {
      act: 'show',
      params: { cfrom: '172|001|02|077', event_id: '172|001|02|077', page_name, position }
    },
    {
      act: 'click',
      params: { cfrom: '172|001|01|077', event_id: '172|001|01|077', page_name, position, sku_id }
    }
  ]

  /** 华丽的分割线-结束 */
}
